import React, { useEffect, useState } from 'react';
import {
  AppInput,
  AppInputNumber,
  AppMultiSelect,
  AppNotificationAlert,
  AppRemixIcon,
  AppSingleSelect,
  AppNoInfo,
} from '@/layout/AppComponents';
import styled from 'styled-components';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Formik } from 'formik';
import ReactDOMServer from 'react-dom/server';
import { axiosPath } from '../../../../../../../routing/helpers/router';
import Translator from '../../../../../../components/helpers/Translator';
import * as currentPageAction from '../../../../../../../store/actions/currentPageAction';

export default function CopisaPenaltyRiskTab(props) {
  const { plantObligationID } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const poLevel3 = useSelector(
    (s) => s.currentPage?.plantObligationLevels?.level3
  );
  const [initialValues, setInitialValues] = useState();
  const [noYesOptions] = useState([
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="no" />
      ),
      value: 0,
    },
    {
      label: ReactDOMServer.renderToString(
        <Translator file="module-comsaEnvironmental" name="yes" />
      ),
      value: 1,
    },
  ]);
  const [commercialPartnersOptions] = useState([
    {
      label: 'Auditores (3)',
      value: 3,
    },
    {
      label: 'Clientes Administraciones públicas (424)',
      value: 424,
    },
    {
      label: 'Clientes privados (163)',
      value: 163,
    },
    {
      label: 'Entidades bancarias (16)',
      value: 16,
    },
    {
      label: 'Partidos políticos (10)',
      value: 10,
    },
    {
      label: 'Socios en UTE (63)',
      value: 63,
    },
    {
      label: 'Organismos Subvenciones (2)',
      value: 2,
    },
    {
      label: 'Organismos Tributarios (4)',
      value: 4,
    },
    {
      label: 'Todos los clientes, proveedores y socios (1239)',
      value: 1239,
    },
  ]);
  const [affectedAreasOptions] = useState([
    {
      label: 'Dir. Compras, Maquinaria',
      value: 0,
    },
    {
      label: 'Contratación y Desarrollo Negocio',
      value: 1,
    },
    {
      label: 'Dirección Construcción',
      value: 2,
    },
    {
      label: 'NS',
      value: 3,
    },
    {
      label: 'Delegación OC Z. Este',
      value: 4,
    },
    {
      label: 'Delegación OC Z. Centro y Sur',
      value: 5,
    },
    {
      label: 'Delegación obras singulares',
      value: 6,
    },
    {
      label: 'Del. Mantenimientos y proyectos urbanos',
      value: 7,
    },
    {
      label: 'Delegación Edificación I',
      value: 8,
    },
    {
      label: 'Delegación Edificación II',
      value: 9,
    },
    {
      label: 'Dirección Integrated Service / mant. Industrial',
      value: 10,
    },
    {
      label: 'Delegación Integrated Services',
      value: 11,
    },
    {
      label: 'Delegación Mantenimiento industrial',
      value: 12,
    },
    {
      label: 'Dir. De Personas y gestión Económica',
      value: 13,
    },
    {
      label: 'PRL',
      value: 14,
    },
    {
      label: 'SIG',
      value: 15,
    },
    {
      label: 'Dpto. Personas / Relaciones Laborales',
      value: 16,
    },
    {
      label: 'Dir. Administración y operaciones financieras',
      value: 17,
    },
    {
      label: 'Contabilidad y Fiscalidad',
      value: 18,
    },
    {
      label: 'Dir. Organización, sistemas e innovación',
      value: 19,
    },
    {
      label: 'Sistemas',
      value: 20,
    },
    {
      label: 'Tesorería',
      value: 21,
    },
    {
      label: 'Asesoría Jurídica',
      value: 22,
    },
    {
      label: 'Imagen y Comunicación',
      value: 23,
    },
  ]);

  // > LOAD DATA TAB
  const loadDataTab = async () =>
    axios
      .post(
        axiosPath("api_r_user_module_legalCompliance_copisaPenaltyRisk_tab"),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
        }
      )
      .then((r) => {
        setInitialValues(r.data);
      });

  useEffect(() => {
    loadDataTab();
  }, []);
  // < LOAD DATA TAB

  // > EDIT
  const handleEdit = async (values, formikBag) => {
    await axios
      .post(
        axiosPath("api_r_user_module_legalCompliance_copisaPenaltyRisk_edit"),
        {
          moduleBridgeHex,
          plantHex,
          plantObligationID,
          values,
        }
      )
      .then((r) => {
        formikBag.setValues(r.data);
        AppNotificationAlert({
          title: ReactDOMServer.renderToString(
            <Translator file="admin" name="completed" />
          ),
          message: ReactDOMServer.renderToString(
            <Translator file="admin" name="calculation-performed-correctly" />
          ),
          type: "success",
          duration: 5000,
        });
        const updatedLevel3 = { ...poLevel3 };
        updatedLevel3[plantObligationID].copisaPenaltyRisk = {
          residualImpact: r.data?.impact?.efficacyAverage,
          residualReputation: r.data?.impact?.reputational,
          residualProbability: r.data?.inherentProbability?.residualProbability,
        };
        dispatch(
          currentPageAction.change("plantObligationLevels", {
            level3: updatedLevel3,
          })
        );
      });
  };
  // < EDIT

  const getThresholdRisk = (thresholdRisk) => {
    if (thresholdRisk < 39.99) return { text: 'Bajo', color: 'bg-green' };
    else if (thresholdRisk >= 40 && thresholdRisk < 59.99)
      return { text: 'Medio', color: 'bg-warning' };
    else return { text: 'Alto', color: 'bg-danger' };
  };

  if (!initialValues) return <AppNoInfo minHeight={300} />;

  return (
    <Container>
      <Formik
        initialValues={initialValues}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={handleEdit}
      >
        {({ setFieldValue, handleSubmit, values, isSubmitting }) => (
          <form onSubmit={handleSubmit}>
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <h3>Impacto</h3>
                </div>
                <div className="col-lg-6">
                  <AppInput
                    icon={<AppRemixIcon icon="font-color" noVariants />}
                    title="Pena de multa para la persona jurídica (texto)"
                    value={values?.impact?.legalPersonFineText}
                    onChange={(v) =>
                      setFieldValue('impact.legalPersonFineText', v)
                    }
                  />
                </div>
                <div className="col-lg-6">
                  <AppInputNumber
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                    title="Pena de multa para la persona jurídica (valor numérico)"
                    value={values?.impact?.legalPersonFineNumber}
                    onChange={(v) =>
                      setFieldValue('impact.legalPersonFineNumber', v)
                    }
                  />
                </div>
                <div className="col-lg-6">
                  <AppInput
                    icon={<AppRemixIcon icon="font-color" noVariants />}
                    title="Pena privativa de libertad para el reo (texto)"
                    value={values?.impact?.freedomPrivativeSentenceText}
                    onChange={(v) =>
                      setFieldValue('impact.freedomPrivativeSentenceText', v)
                    }
                  />
                </div>
                <div className="col-lg-6">
                  <AppInputNumber
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                    title="Pena privativa de libertad para el reo (valor numérico)"
                    value={values?.impact?.freedomPrivativeSentenceNumber}
                    onChange={(v) =>
                      setFieldValue('impact.freedomPrivativeSentenceNumber', v)
                    }
                  />
                </div>
                <div className="col-lg-6">
                  <AppInput
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                    title="Efectividad"
                    value={values?.impact?.efficacyAverage}
                    isReadOnly
                  />
                </div>
                <div className="col-lg-6">
                  <AppMultiSelect
                    title="Reputacional"
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                    options={[
                      {
                        value: 'image',
                        label: 'Imagen',
                      },
                      {
                        value: 'credibility',
                        label: 'Credibilidad',
                      },
                      {
                        value: 'transparency',
                        label: 'Transparencia',
                      },
                      {
                        value: 'integrity',
                        label: 'Integridad',
                      },
                      {
                        value: 'contribution',
                        label: 'Contribución',
                      },
                    ]}
                    value={values?.impact?.reputational}
                    onChange={(v) => setFieldValue('impact.reputational', v)}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <h3>Probabilidad</h3>
                </div>
                <div className="col-lg-6">
                  <AppInputNumber
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                    title="Nº empleados expuestos"
                    value={values?.inherentProbability?.exposedEmployeeNumber}
                    onChange={(v) =>
                      setFieldValue(
                        'inherentProbability.exposedEmployeeNumber',
                        v
                      )
                    }
                  />
                </div>
                <div className="col-lg-6">
                  <AppInputNumber
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                    title="Valor (base 100) Total empleados 878"
                    value={
                      values?.inherentProbability?.totalEmployeeNumberValue
                    }
                    onChange={() => {}}
                    readOnly
                  />
                </div>
                <div className="col-lg-6">
                  <AppSingleSelect
                    options={commercialPartnersOptions}
                    title="Nº socios comerciales y otros organismos"
                    value={values?.inherentProbability?.commercialPartners}
                    onChange={(v) =>
                      setFieldValue('inherentProbability.commercialPartners', v)
                    }
                    isClearable
                  />
                </div>
                <div className="col-lg-6">
                  <AppInputNumber
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                    title="Valor (base 100) Total socios comerciales 1239"
                    value={values?.inherentProbability?.commercialPartnersValue}
                    onChange={() => {}}
                    readOnly
                  />
                </div>
                <div className="col-lg-6">
                  <AppInputNumber
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                    title="Probabilidad inherente"
                    value={values?.inherentProbability?.average}
                    onChange={() => {}}
                    readOnly
                  />
                </div>
                <div className="col-lg-6 d-flex align-items-center gap-2">
                  <div style={{ flex: 1 }}>
                    <AppInputNumber
                      icon={<AppRemixIcon icon="hashtag" noVariants />}
                      title="Media de efectividades"
                      value={values?.inherentProbability?.efficacyAverage}
                      onChange={() => {}}
                      readOnly
                    />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    <span
                      className="border border-solid text-primary font-weight-bold"
                      style={{ padding: '6.5px', marginTop: '3px' }}
                    >
                      EFcontrol=(I+E)/2
                    </span>
                  </div>
                </div>
                <div className="col-lg-12">
                  <AppInputNumber
                    icon={<AppRemixIcon icon="hashtag" noVariants />}
                    title="Probabilidad residual"
                    value={values?.inherentProbability?.residualProbability}
                    onChange={() => {}}
                    readOnly
                  />
                </div>
                <div className="col-lg-12 mt-4">
                  <AppMultiSelect
                    options={affectedAreasOptions}
                    title="Áreas afectada"
                    value={values?.affectedAreas}
                    onChange={(v) => setFieldValue('affectedAreas', v)}
                  />
                </div>
                <div className="col-lg-6">
                  <AppSingleSelect
                    options={noYesOptions}
                    title="37001"
                    value={values?.input37001}
                    onChange={(v) => setFieldValue('input37001', v)}
                  />
                </div>
                <div className="col-lg-6">
                  <AppSingleSelect
                    options={noYesOptions}
                    title="19601"
                    value={values?.input19601}
                    onChange={(v) => setFieldValue('input19601', v)}
                  />
                </div>
                <div className="col-lg-6 d-flex align-items-center gap-2">
                  <div style={{ flex: 1 }}>
                    <AppInputNumber
                      icon={<AppRemixIcon icon="hashtag" noVariants />}
                      title="Media impacto inherente , reuptacional y probabilidad"
                      value={values?.thresholdRisk}
                      onChange={() => {}}
                      readOnly
                    />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      height: '100%',
                    }}
                  >
                    <span
                      className={`border border-solid text-primary font-weight-bold ${
                        getThresholdRisk(values?.thresholdRisk).color
                      }`}
                      style={{ padding: '6.5px', marginTop: '3px' }}
                    >
                      {getThresholdRisk(values?.thresholdRisk).text}
                    </span>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <button
                    type="submit"
                    className="btn btn-xs btn-success float-right mb-2"
                    disabled={isSubmitting}
                  >
                    Editar
                  </button>
                </div>
              </div>
            </div>
          </form>
        )}
      </Formik>
    </Container>
  );
}

const Container = styled.div`
  height: 400px;
  overflow-y: auto;
`;
